import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.214 9.35q.028.323.028.651a7.24 7.24 0 1 1-6.588-7.211q-.212.662-.241 1.385a5.84 5.84 0 1 0 5.415 5.417 5.2 5.2 0 0 0 1.386-.241",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m7.437 10.988-.003-.003.002.002m5.135-.003-.003.003-.024.026a3.6 3.6 0 0 1-.626.477 3.69 3.69 0 0 1-3.831 0 3.6 3.6 0 0 1-.626-.477l-.025-.026-.003-.003a.7.7 0 0 0-1.041.935l.522-.466-.522.466v.001l.001.001.003.003.005.006.017.018.054.056q.068.068.19.176a5.09 5.09 0 0 0 5.978.509 5 5 0 0 0 .893-.685l.054-.056.016-.018.006-.006.002-.003h.001s.001-.002-.521-.468l.522.466a.7.7 0 0 0-1.042-.935M8.79 8.7a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.99 8.5a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4m0 1a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6m5.018-.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.208 8.5a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4m0 1a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6M15.5 1.3a.7.7 0 0 1 .7.7v1.8H18a.7.7 0 1 1 0 1.4h-1.8V7a.7.7 0 1 1-1.4 0V5.2H13a.7.7 0 1 1 0-1.4h1.8V2a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AddEmojiIcon20.js.map